import { Injectable, OnDestroy } from '@angular/core';
import * as howler from 'howler';

// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
@Injectable()
export class TrPlayerSoundTrackService implements OnDestroy {

    private muted: boolean;
    private foregroundSoundTrackVolumeLevel: number = 0.176;
    private backgroundSoundTrackVolumeLevel: number = 0.069;
    private volumeTransitionTime: number = 800;
    private soundTrack: any;
    private soundTrackId: number;
    private loopStart: number;
    private isPlaying: boolean = false;

    /** Define quando o loop da trilha começa */
    public setLoopStart(second: number) {
        this.loopStart = second;
    }

    /**
     * Carrega e inicia a execução de uma trilha
     * @param soundTrackSrc caminho para a trilha (arquivo de aúdio válido)
     * @param initialVolume volume inicial. Se não informado o padrão será usado
     */
    public load(soundTrackSrc: string, initialVolume: number = null) {
        this.soundTrack = new howler.Howl({
            src: [soundTrackSrc],
            volume: this.backgroundSoundTrackVolumeLevel,
            loop: false,
            html5: true,
        });

        this.soundTrack.on('end', () => {
            this.soundTrack.seek(this.loopStart, this.soundTrackId);
            if (this.isPlaying) {
                this.play();
            } else {
                this.pause();
            }
        });
    }

    public play() {
        if (this.muted !== true) {
            if (this.soundTrackId === undefined) {
                this.soundTrackId = this.soundTrack.play();
                this.isPlaying = true;
            } else {
                this.soundTrack.play(this.soundTrackId);
                this.isPlaying = true;
            }
        }
    }

    public pause() {
        if (this.soundTrack.playing()) {
            this.soundTrack.pause();
            this.isPlaying = false;
        }
    }

    public fadeOut() {
        if (this.muted !== true) {
            this.soundTrack.fade( this.soundTrack.volume(), this.backgroundSoundTrackVolumeLevel, this.volumeTransitionTime, this.soundTrackId);
        }
    }

    public fadeIn() {
        if (this.muted !== true) {
            this.soundTrack.fade(
                this.backgroundSoundTrackVolumeLevel,
                this.foregroundSoundTrackVolumeLevel,
                this.volumeTransitionTime,
                this.soundTrackId,
            );
        }
    }

    public stop() {
        this.soundTrack.stop();
        this.isPlaying = false;
    }

    public reset() {
        this.soundTrack.unload();
        this.soundTrack = null;
        this.soundTrackId = null;
        this.muted = false;
    }

    public mute(mute: boolean) {
        this.muted = mute;
    }

    public getCurrentVolume() {
        if (this.soundTrack) {
            return this.soundTrack.volume();
        }

        return 0;
    }

    // tslint:disable-next-line:no-empty
    public ngOnDestroy() {}
}
